<div class="no-data-label">
  <div class="no-data-label__title">{{ noDataTitle }}</div>
  <div class="no-data-label__subtitle">{{ noDataSubtitle }}</div>
</div>
